export default "__VITE_ASSET__WDuUv8L5__"